import { motion } from "framer-motion";

export const EASE = [0.16, 1, 0.3, 1];

export function FadeUp({ children, delay = 0, y = 28, className = "" }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.7, delay, ease: EASE }}
    >
      {children}
    </motion.div>
  );
}

export function Overline({ children, className = "" }) {
  return (
    <p
      className={`text-[11px] font-bold uppercase tracking-[0.22em] ${className}`}
    >
      {children}
    </p>
  );
}

export function KineticLines({ lines, lineClass = "", delay = 0, stagger = 0.13 }) {
  return (
    <span className="block">
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden pb-[0.08em] -mb-[0.08em]">
          <motion.span
            className={`block ${lineClass}`}
            initial={{ y: "112%" }}
            animate={{ y: 0 }}
            transition={{ duration: 0.95, delay: delay + i * stagger, ease: EASE }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </span>
  );
}

export function SectionHead({ overline, title, copy, light = false, className = "" }) {
  return (
    <FadeUp className={`max-w-2xl ${className}`}>
      <Overline className={light ? "text-terra" : "text-terra"}>{overline}</Overline>
      <h2
        className={`font-display mt-4 text-3xl font-extrabold tracking-tight sm:text-4xl lg:text-[2.75rem] lg:leading-[1.08] ${
          light ? "text-bone" : "text-forest-700"
        }`}
      >
        {title}
      </h2>
      {copy ? (
        <p className={`mt-4 text-base leading-relaxed ${light ? "text-bone/70" : "text-moss"}`}>
          {copy}
        </p>
      ) : null}
    </FadeUp>
  );
}
